import Button from '../../../components/Button/Button';
import { listSolutionsItems } from '../../../data/data';
import { ClassNameProps, Item, SectionsProps } from '../../../types/types';

const ListSolutions: React.FC<ClassNameProps & SectionsProps> = ({
  className,
  openModal,
}) => {
  return (
    <>
      <ul className={className}>
        {listSolutionsItems.map((item: Item) => (
          <li
            key={item.id}
            className={`${className}__item card${
              item.class ? ` ${item.class}` : ''
            }`}
          >
            <div className={`${className}__inner`}>
              <h3 className={`${className}__title subtitle`}>{item.title}</h3>
              <p className={`${className}__text text-normal`}>{item.text}</p>
            </div>
            {item.button && (
              <Button className={`${className}__button`} onClick={openModal}>
                {item.button}
              </Button>
            )}
            {item.img && (
              <img
                src={item.img}
                className={`${className}__img`}
                alt={item.title}
              />
            )}
            {item.svg && <>{item.svg}</>}
          </li>
        ))}
      </ul>
    </>
  );
};
export default ListSolutions;
